<template>
	<div class="modal inmodal fade modal-v5" tabindex="-1" role="dialog" id="modalDisconnectFunnels">
		<div class="modal-dialog modal-sm" role="document">
			<div class="modal-content" v-if="!loading">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <h2 class="modal-title is-danger" v-text="translations.title_disconnect"></h2>
                </div>
                <div class="modal-body">
                    <p class="info-text-disconnect" v-html="translations.sure_disconnect"></p>
                    <div class="bottom-buttons">
                        <button class="btn-modal btn-red-modal" @click="disconnect()" v-html="translations.disconnect"></button>
                        <button class="btn-modal btn-blue-modal" data-dismiss="modal" aria-hidden="true" v-html="translations.disconnect_cancel"></button>
                    </div>
                </div>
			</div>
			<div class="modal-content" v-else>
                <div class="modal-header">
                     <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <br>
                </div>
                <div class="modal-body text-center">
                    <img class="modal-loader" src="/internacional/public/office4/img/dashboard/load-2.svg"/>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
import qs from "qs";
export default {
    props:['route'],
    data() {
        return {
            loading: true,
            translations: {},
            lang: window.lang || 'us',
        };
    },
    methods:{
        initialize : function(){
            this.loadData();
        },
        loadData: function(){
            let vm = this;
            vm.loading = true;
            axios
                .get(`/${vm.lang}/office/funnels/connect-domain/get-data`)
                .then((response)=>{
                    if(response.data.success){
                        vm.translations = response.data.data.translations;
                    }
                })
                .catch((error)=>{
                    console.error(error);
                })
                .finally(()=>{
                    vm.loading = false;
                });
        },
        disconnect: function(){
            let vm = this;
            vm.loading = true;
            axios
                .get(`/${vm.lang}/office/franchise-system/share/domain`)
                .then((response)=>{
                    if(response.data.status == 'success'){
                        alertMsg("success", vm.translations.success_to_disconnect)
                        vm.close()
                        vm.treatRedir();
                    }else{
                        alertMsg("error", vm.translations.error)
                    }
                })
                .catch((error)=>{
                    alertMsg("error", vm.translations.error)
                    console.error(error);
                })
                .finally(()=>{
                    vm.loading = false;
                });
        },
        close: function(){
            $('#modalDisconnectFunnels').modal('hide');
        },
        treatRedir: function(){
            let url =  window.location.href;
            url = this.removeUrlParam('opentool', url);
            url = this.removeUrlParam('connected-domain', url);

            window.location.href = url;
        },
        removeUrlParam: function(key, sourceURL) {
            var rtn = sourceURL.split("?")[0],
                param,
                params_arr = [],
                queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
            if (queryString !== "") {
                params_arr = queryString.split("&");
                for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                    param = params_arr[i].split("=")[0];
                    if (param === key) {
                        params_arr.splice(i, 1);
                    }
                }
                if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
            }
            return rtn;
        }
    },
    mounted(){
        this.initialize();
    },
}
</script>


<style scoped lang="scss">
    .close{
        color: #C4C4C4 !important;
    }
    .modal-title{
        text-align: left !important;
        padding-left: 1em;
        color: #A5B9D5 !important;
        font-size: 1.8em !important;
        font-family: Lato;
        text-transform: uppercase;
    }
    .modal-body {
        padding-top: 0;
        .form-group{
            span {
                font-size: 15px;
                padding-top: 5px;
                padding-left: 5px;
            }
        }

        .modal-loader{
            width: 100px;
        }

        label{
            font-weight: bold !important;
        }

        .info-text-disconnect{
            margin-bottom: 1em;
            font-size: .9em;
            text-align: left;
            line-height: 1.5em;
            font-family: 'Lato';
        }

        .invalid {
            display: block;
            font-size: 12px !important;
            color: #f54b53;
        }

        .font-muli{
            font-family: 'Muli-Regular';
        }

        .font-mulish{
            font-family: 'Mulish';
        }

        .bottom-buttons{
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between;
            gap: 3%;
            .btn-modal{
                font-family: "Lato";
                font-weight: bold;
                font-size: .9em;
                padding: 1em;
                border: none;
                border-radius: 8px;
                color: #fff;
                outline: none;
                width: 48%;
                transition: .4s;
            }
            .btn-red-modal{
                background-color: #EFEFEF;
                color: #A5B9D5;
            }
            .btn-red-modal:hover{
                background-color: #EF4411;
                color: #fff;
            }
            .btn-blue-modal{
                background-color: #0080FC;
            }
        }

        .btn__normal{
            margin: 12px;
            width: 170px;
            height: 40px;
        }
    }

</style>


// WEBPACK FOOTER //
// resources/office/js/components/domains-storage/disconnectDomainFunnels.vue